import { useQueryClient, useMutation } from 'react-query'
import { type ExpertDomain } from '../../../../types/domain/expert-domain'
import { type ExpertAcceptTermsPersistence } from '../../../../types/persistence/expert-accept-terms-persistence'
import { api } from '../../../api'

const acceptTermsExpert = async (id: number, data: ExpertAcceptTermsPersistence) => {
  const response = await api.patch(`/experts/${id}/accept-terms`, data)
  return response.data
}

export const useExpertAcceptTermsMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number, data: ExpertAcceptTermsPersistence }) => {
      return acceptTermsExpert(id, data)
    },
    onSuccess (data: ExpertDomain) {
      queryClient.setQueryData(['expert', data.id], data)
    }
  })
}
